import { notifications } from '@/libs/api'
import { defineStore } from 'pinia'
import { NotificationsListDecorator } from '@/layouts/default/modals/Notifications/decorators/NotificationsListDecorator'

export const useNotifications = defineStore('notifications', {
  state: () => ({
    allUnreadCount: null,
    requiredUnreadCount: null,
    unreadItems: [],
    unreadRequiredItems: [],
  }),
  actions: {
    async getNotificationsInfo() {
      const { data } = await notifications.getInfo()

      await this.getNotifications()

      this.allUnreadCount = data.allUnread
      this.requiredUnreadCount = data.requiredUnread

      if (this.requiredUnreadCount) {
        await this.getNotifications('REQUIRED')
      } else {
        this.unreadRequiredItems = []
      }
    },

    resetUnreadNotifications() {
      this.unreadItems = []
      this.allUnreadCount = null
    },

    async getNotifications(type = null) {
      const params = {
        isViewed: Number(false),
        sort: '-createdAt',
        type: type,
      }
      const { data } = await notifications.getList(params)

      if (type) {
        this.unreadRequiredItems = NotificationsListDecorator(data)
      } else {
        this.unreadItems = NotificationsListDecorator(data)
      }
    },
  },
})
